import { useParams, useHistory } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import useHistoryDetail from 'data/hooks/useHistoryDetail';
import useOrderActions from 'data/hooks/useOrderActions';
import { markOrderAsSeen } from 'data/cacheHelpers/order';

const useConnect = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const { location, push } = useHistory<{ prevPathname: string }>();
  const { order, isLoading } = useHistoryDetail(orderId);
  const { printOrder } = useOrderActions();

  useEffect(() => markOrderAsSeen(orderId), [orderId]);

  const handleClose = useCallback(() => {
    const prevLocation =
      (location.state && location.state.prevPathname) || '/history';

    push(prevLocation);
  }, [location, push]);

  const handlePrintOrder = useCallback(
    () => printOrder({ orderId }),
    [printOrder, orderId],
  );

  return {
    orderId,
    handleClose,
    order,
    isLoading,
    handlePrintOrder,
  };
};

export default useConnect;
